/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-instant-rebates',
    'pip-value-pricing-tooltip',
    'thd.quicktip',
    'pip-events',
    'pip-model'
], function(
    pipInstantRebates,
    valuePricingTooltip,
    thdQuicktip,
    pipEvents,
    pip
){
    var view = {
        selectors: {
            priceContainer: '.buybox__price',
            valuePricingLink: '.buybox__price .map-pricing__message'
        }
    }
    //TODO: Remove thd.Quicktip and use either global or pip-tooltip
    function initEventListeners(){
        $(document).off('.tipOpener').on('click.tipOpener', '.product_promo_ctn a.tip-Opener', function(){
            pipEvents.promotionLinkClicked.trigger({eventName: 'promo details'});
        });

        pipEvents.dualPath.dualPathOptInStateChanged.off('.priceDualPathStateChanged');
        pipEvents.dualPath.dualPathOptInStateChanged.on('.priceDualPathStateChanged', function() {
            $(view.selectors.priceContainer).toggle(!pip.customer.dualPath.isOptedIn);
        });
    }
    return {
        init: function init() {
            initEventListeners();
            pipInstantRebates.init();
            valuePricingTooltip.init(view.selectors.valuePricingLink);
        }
    }
});

}.call(window));